import { useState } from "react";

import {
  IdentityQueueCandidate,
  IdentityQueueEntry,
} from "../utils/identity-queue";

export interface IdentityQueueState<TItem extends IdentityQueueCandidate> {
  current: IdentityQueueEntry<TItem> | null;
  position: number;
  total: number;
  resolvedCount: number;
  skippedCount: number;
  isDone: boolean;
  resolve: () => void;
  skip: () => void;
}

/**
 * D12: a fila não decide nada — ela caminha. Cada item é reenviado pelo caminho
 * individual e é a API que volta a dizer se cabe informar o CPF, então aqui não
 * existe leitura de falha nem de elegibilidade.
 */
export function useIdentityQueue<TItem extends IdentityQueueCandidate>(
  entries: readonly IdentityQueueEntry<TItem>[],
): IdentityQueueState<TItem> {
  const [index, setIndex] = useState<number>(0);
  const [resolvedCount, setResolvedCount] = useState<number>(0);

  const total: number = entries.length;
  const isDone: boolean = index >= total;

  const advance = (): void =>
    setIndex((current: number): number => current + 1);

  const resolve = (): void => {
    setResolvedCount((current: number): number => current + 1);
    advance();
  };

  return {
    current: isDone ? null : entries[index],
    position: Math.min(index + 1, total),
    total,
    resolvedCount,
    skippedCount: index - resolvedCount,
    isDone,
    resolve,
    skip: advance,
  };
}
